export class Anim {
    constructor(stepOffset, fromPosition, fromRotation) {
        this.stepOffset = stepOffset;
        this.fromPosition = fromPosition.clone();
        this.fromRotation = fromRotation.clone();
    }
    slideTo(position) {
        this.toPosition = position;
    }
    turnTo(rotation) {
        this.toRotation = rotation;
    }
    apply(target, step) {
        if (this.toPosition) {
            target.position.copy(this.fromPosition).lerp(this.toPosition, step - this.stepOffset);
        }
        if (this.toRotation) {
            target.quaternion.copy(this.fromRotation).slerp(this.toRotation, step - this.stepOffset);
        }
    }
}
